// extracted by mini-css-extract-plugin
export default {"content":"bX2W9","icon":"Jiixc","info":"eGMtM","sub_info":"fgACr","text":"_oiyg","subtext":"j8JYz"};